"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var EventBindingOnLevelCfgEditor = /** @class */ (function (_super) {
    __extends(EventBindingOnLevelCfgEditor, _super);
    function EventBindingOnLevelCfgEditor(props) {
        return _super.call(this, props) || this;
    }
    EventBindingOnLevelCfgEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            this.props.data.LoadData(this.props.record.key, function () {
                _this.setState({
                    is_bonus_create_on_less_or_eq_then_level_number: _this.props.data.DATA.is_bonus_create_on_less_or_eq_then_level_number,
                    bonus_create_on_less_or_eq_then_level_number: _this.props.data.DATA.bonus_create_on_less_or_eq_then_level_number,
                    is_bonus_create_on_greater_then_level_number: _this.props.data.DATA.is_bonus_create_on_greater_then_level_number,
                    bonus_create_on_greater_then_level_number: _this.props.data.DATA.bonus_create_on_greater_then_level_number
                });
            });
        }
        this.setState({
            is_bonus_create_on_less_or_eq_then_level_number: false,
            bonus_create_on_less_or_eq_then_level_number: 0,
            is_bonus_create_on_greater_then_level_number: false,
            bonus_create_on_greater_then_level_number: 0
        });
        //
        //this.props.state.setExtBreadCrumbPath(["Настройка обработчика события <уровень>"]);
        this.props.state.setExtBreadCrumbPath(["\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430 - [" + this.props.record.title + "]"]);
        this.doReSetRules();
    };
    EventBindingOnLevelCfgEditor.prototype.doReSetRules = function () {
        this.setState({
            bonus_create_on_less_or_eq_then_level_number_rules: { isError: false },
            bonus_create_on_greater_then_level_number_rules: { isError: false }
        });
    };
    EventBindingOnLevelCfgEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if (this.state.is_bonus_create_on_less_or_eq_then_level_number) {
            if ((!this.state.bonus_create_on_less_or_eq_then_level_number) || (this.state.bonus_create_on_less_or_eq_then_level_number <= 0)) {
                this.setState({
                    bonus_create_on_less_or_eq_then_level_number_rules: { isError: true, errorMessage: "Поле [Номер уровня] заполнено некорректно!" },
                });
                return false;
            }
        }
        if (this.state.is_bonus_create_on_greater_then_level_number) {
            if ((this.state.bonus_create_on_greater_then_level_number <= 0) || (this.state.bonus_create_on_greater_then_level_number > 1000)) {
                this.setState({
                    bonus_create_on_greater_then_level_number_rules: { isError: true, errorMessage: "Поле [Максимальный номер уровня] заполнено некорректно!" }
                });
                return false;
            }
        }
        return true;
    };
    EventBindingOnLevelCfgEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                event_binding_id: this.props.record.key,
                is_bonus_create_on_less_or_eq_then_level_number: this.state.is_bonus_create_on_less_or_eq_then_level_number,
                bonus_create_on_less_or_eq_then_level_number: this.state.bonus_create_on_less_or_eq_then_level_number,
                is_bonus_create_on_greater_then_level_number: this.state.is_bonus_create_on_greater_then_level_number,
                bonus_create_on_greater_then_level_number: this.state.bonus_create_on_greater_then_level_number
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Настройки обработичка события <уровень> изменены!");
            });
        }
    };
    EventBindingOnLevelCfgEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    EventBindingOnLevelCfgEditor.prototype.getFormTitle = function () {
        return "Изменить настройки обработчика события <уровень>";
    };
    EventBindingOnLevelCfgEditor.prototype.getActionButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    EventBindingOnLevelCfgEditor.prototype.getContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Создавать бонус только на порядковый номер уровня меньше либо равно", value: this.state.is_bonus_create_on_less_or_eq_then_level_number, onChecked: function (checked) {
                    _this.setState({
                        is_bonus_create_on_less_or_eq_then_level_number: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Порядковый номер уровня:", placeholder: "Введите порядковый номер уровня" }, values: { max: 9999, min: 1, value: this.state.bonus_create_on_less_or_eq_then_level_number }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_create_on_less_or_eq_then_level_number: newVal,
                        bonus_create_on_less_or_eq_then_level_number_rules: { isError: false }
                    });
                }, disabled: !this.state.is_bonus_create_on_less_or_eq_then_level_number, rules: this.state.bonus_create_on_less_or_eq_then_level_number_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Создавать бонус только на порядковый номер уровня больше чем", value: this.state.is_bonus_create_on_greater_then_level_number, onChecked: function (checked) {
                    _this.setState({
                        is_bonus_create_on_greater_then_level_number: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Порядковый номер уровня:", placeholder: "Введите порядковый номер уровня" }, values: { max: 999999999, min: 1, value: this.state.bonus_create_on_greater_then_level_number }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_create_on_greater_then_level_number: newVal,
                        bonus_create_on_greater_then_level_number_rules: { isError: false }
                    });
                }, disabled: !this.state.is_bonus_create_on_greater_then_level_number, rules: this.state.bonus_create_on_greater_then_level_number_rules }),
            this.getActionButtons()));
    };
    EventBindingOnLevelCfgEditor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400 }, this.getContent()));
    };
    return EventBindingOnLevelCfgEditor;
}(React.Component));
exports.default = EventBindingOnLevelCfgEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ui/component/event_config/on_level/EventBindingOnLevelCfgEditor.tsx
// module id = 1983
// module chunks = 0